import { render } from "./PopupDetail.vue?vue&type=template&id=e38b605a&scoped=true"
import script from "./PopupDetail.vue?vue&type=script&lang=js"
export * from "./PopupDetail.vue?vue&type=script&lang=js"

import "./PopupDetail.vue?vue&type=style&index=0&id=e38b605a&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38b605a"]])

export default __exports__